import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import ToggleTabs from '@cp/src/components/toggleTabs/ToggleTabs';
import React from 'react';
import { Controller } from 'react-hook-form';
import { ToggleTabsProps } from '../../interfaces/types';
import { Typography } from '@navi/web-ui/lib/primitives';

const FormToggleTab: React.FC<ToggleTabsProps> = props => {
  const {
    control,
    name,
    tabOptions,
    rules,
    errors,
    styles,
    validationMessage,
    handleToggleClick,
    isToggleDisabled = false
  } = props;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value } }) => {
          return (
            <ToggleTabs
              selected={value}
              onTabClick={selectedValue => {
                if (isToggleDisabled) {
                  return;
                }
                onChange(selectedValue);
                handleToggleClick(selectedValue);
              }}
              tabOptions={tabOptions}
              size="h6"
              containerClass="h-7 text-primary"
              tabClass="!mt-0 !mb-0"
              isToggleDisabled={isToggleDisabled}
            />
          );
        }}
      />
      {errors?.[name] ? (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      ) : null}
    </>
  );
};

export default FormToggleTab;
